// extracted by mini-css-extract-plugin
module.exports = {"search-page-ad-banner":"SearchPageAdBanner_search-page-ad-banner__41YZ5"};